import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from "../../../_services/alert.service";
import { environment } from "../../../../environments/environment";
import { ApiHttpService } from "../../../_services/api-http.service";
import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';
import { MerchantService } from '../merchants/merchant-master/merchant.service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';
const { API_URL } = environment;
@Component({
  selector: 'app-merchant-report',
 templateUrl: './merchant-report.component.html',
 
  styleUrls: ['./merchant-report.component.scss'],
  template: `
    <div [innerHTML]="htmlContent"></div>
    <button (click)="loadHtmlFile()">Load HTML File</button>
  `
})
export class MerchantReportComponent implements OnInit {
  orvreport: FormGroup;
  Resultdata: any;
  merchantId:any;
  mindatadis: boolean = true;
  loading: boolean = false;
  htmlContent: string;
  path:string;
  public permissions: any='';
  constructor(private  formBuilder: FormBuilder, private menuService: MenusService, private apiHttpService: ApiHttpService,private alertService: AlertService,private location: Location,private merchantService: MerchantService ) {
    this.orvreport = formBuilder.group({
      merchantId: ["", Validators.required],
      fileupload:["",Validators.required],
    })
  }
  ngOnInit(): void {
    this.path = this.location.prepareExternalUrl(this.location.path());
    this. mindatadis = true;
    let merchantdata = { "name": "" }
  this.apiHttpService
    .post(`${API_URL}/GetMerchant`, merchantdata)
    .subscribe((res) => {
      this.Resultdata = res
    });
  }
  hmnlpage:any;
   Merchantdata:any;
  onSubmit(formvalue: any): void {
    this.loading = true
    this. mindatadis = true;
     this.Merchantdata=formvalue.merchantId;
debugger
    this.apiHttpService
    .post(
      `${API_URL}/docs/download/${formvalue.merchantId}/MCR`, null
      )
    .subscribe((data) => (
     this.downloadPdf(data,this.Merchantdata)
    ));
  }
  downloadPdf(data:any,Merchant:any) {
if(data){
    const linkSource =
    'data:application/octet-stream;base64,' +data.text;
    const downloadLink = document.createElement('a');
    const fileName = 'Merchant_'+Merchant+'.pdf';
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    this.loading = false
  }else{
    this. mindatadis = false;
    this.loading = false
  }
  }
  downloadAutomated(){
   
    debugger
  //  let   mid=20230001;
    this.apiHttpService.post(`${API_URL}/mergeBasicReport/${this.merchantid}`, null)
    .subscribe((data) => (
     this.downloadPdfauto(data,this.merchantid)
    ));
  
  }
  downloadPdfauto(data:any,Merchant:any) {
 //alert("JSON DATA"+JSON.stringify(data))
 // alert("data"+data)
    if(data){
      this. mindatadis = true;
        const linkSource =
        'data:application/octet-stream;base64,' +data.text;
        const downloadLink = document.createElement('a');
        const fileName = 'AVR_'+Merchant+'.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.loading = false
      }else{
        
        this. mindatadis = false;
        this.loading = false
      }
      }
  downloadManual(){
   let   mid=2308829032;
    this.apiHttpService
    .post(
      `${API_URL}/merge/${this.merchantid}`, null
      )
    .subscribe((data) => (
     this.downloadPdfmanu(data,this.merchantid)
    ));
  }
  downloadPdfmanu(data:any,Merchant:any) {
    if(data){
        const linkSource =
        'data:application/octet-stream;base64,' +data.text;
        const downloadLink = document.createElement('a');
        const fileName = 'MVR_'+Merchant+'.pdf';
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        this.loading = false
      }else{
        this. mindatadis = false;
        this.loading = false
      }
      }

  merchantid:any;
  showhtml:boolean=false
  onSelectMerchant(event:any){
    this. mindatadis = true;
    this.permissions = this.menuService.getPermissions(this.path);

    if(event==undefined){
      this.showhtml=false
    }
    else{
     // alert(event);
      this.merchantid=event;
      this.showhtml=true
      this.getBtnFlag(event);
    }
  }
  btnflag:any;
  btnpan:any
  btnvaluepan:any
  btnvalue:any;
  btnvalue1:any;
  btngst:any
  btnvaluegstn:any
  btnmca:any
  btnvaluemca:any
  btnaccount:any
  btnvalueaccount:any
  btnweb:any
  btnvalueweb:any
  btncibil:any
  btnvaluecibil:any
  btnfiu:any
  btnvaluefiu:any
  btnpep:any
  btnvaluepep:any
  btnnmas:any
  btnvaluenmas:any
  btnaml:any
  btnvalueaml:any
  osvbtn:any
  osvvalue:any
  irabtn:any
  iravalue:any
  mcmTncBtn:any
  mcmTncValue:any
  mcmMrpBtn:any
  mcmMrpValue:any
  mcmMGPbtn:any
  mcmMGPValue:any
  mcmAOCbtn:any
  mcmAOCValue:any
  mcmCOCBtn:any
  mcmCOCValue:any
  mcmVaptbtn:any
  mcmVaptValue:any
  verificationReponse:any


     
//   "panVerification": try,
//   "gstn": false,
//   "mca": false,
//   "accountVerification": false,
//   "webCrawler": false,
//   "cibilAndSmr": false,
//   "pepSanction": false,
//   "fiuIntegration": false,
//   "nmasVmtsMatch": false,
//   "amlVerify": false,
//   "negativeData": null,
//   "verifiedDate": null

getBtnFlag(merchantidd:any){
 //alert(merchantidd);
  ///verification/details/{merchantId}

  this.apiHttpService.post(`${API_URL}/verification/details/${merchantidd}`, null).subscribe((data) => {    
    this.btnflag=JSON.stringify(data);
    this.verificationReponse=data
    //alert(JSON.stringify(data))
    console.log("verification details"+JSON.stringify(data))
    //alert(data)
   // const statusButton = document.getElementById('statusButton');
    let val=false;
    // data.panVerification
    // data.gstn
    // data.mca
    // data.accountVerification
    // data.webCrawler
    // data.cibilAndSmr
    // data.pepSanction
    // data.fiuIntegration
    // data.nmasVmtsMatch
    // data.amlVerify
    // data.negativeData
    // data.verifiedDate

    if(data.panVerification){
      this.btnpan='btn btn-success btn-sm'; 
      this.btnvaluepan="Received"
    }if(data.panVerification==false){
      this.btnpan='btn btn-danger btn-sm'; 
      this.btnvaluepan="Retry"
    }
    if( data.gstn){
      this.btngst='btn btn-success btn-sm'; 
      this.btnvaluegstn="Received"
    }
    if( data.gstn==false){
      this.btngst='btn btn-danger btn-sm'; 
      this.btnvaluegstn="Retry"
    }
    if(data.mca){
      this.btnmca='btn btn-success btn-sm'; 
      this.btnvaluemca="Received"
    }
    if(data.mca==false){
      this.btnmca='btn btn-danger btn-sm'; 
      this.btnvaluemca="Retry"
    }
    if(data.accountVerification){
      this.btnaccount='btn btn-success btn-sm'; 
      this.btnvalueaccount="Received"
    }
    if(data.accountVerification==false){
      this.btnaccount='btn btn-danger btn-sm'; 
      this.btnvalueaccount="Pending"
    }
    if(data.webCrawler){
      this.btnweb='btn btn-success btn-sm'; 
      this.btnvalueweb="Received"
    }
    if(data.webCrawler==false){
      this.btnweb='btn btn-danger btn-sm'; 
      this.btnvalueweb="Retry"
    }
    if(data.cibilAndSmr){
      this.btncibil='btn btn-success btn-sm'; 
      this.btnvaluecibil="Verified"
    }
    if(data.amlVerify){
      this.btnaml='btn btn-success btn-sm'; 
      this.btnvalueaml="Received"
    }
    if(data.amlVerify==false){
      this.btnaml='btn btn-danger btn-sm'; 
      this.btnvalueaml="Retry"
    }
    if(data.pepSanction){
      this.btnpep='btn btn-success btn-sm'; 
      this.btnvaluepep="Uploaded"
    }
    if(data.pepSanction==false){
      this.btnpep='btn btn-danger btn-sm'; 
      this.btnvaluepep="Not Uploaded"
    }
    if( data.fiuIntegration){
      this.btnfiu='btn btn-success btn-sm'; 
      this.btnvaluefiu="Verified"
    }
    if( data.fiuIntegration){
      this.btnfiu='btn btn-success btn-sm'; 
      this.btnvaluefiu="Verified"
    }
    if(data.nmasVmtsMatch){
      this.btnnmas='btn btn-success btn-sm'; 
      this.btnvaluenmas="Verified"
    }
    if(data.nmasVmtsMatch){
      this.btnnmas='btn btn-success btn-sm'; 
      this.btnvaluenmas="Verified"
    }  
   
    if(data.osv){
      this.osvbtn='btn btn-success btn-sm'; 
      this.osvvalue="Uploaded"
    }
    if(data.osv==false){
      this.osvbtn='btn btn-danger btn-sm'; 
      this.osvvalue="Not Uploaded"
    }

    if(data.ira){
      this.irabtn='btn btn-success btn-sm'; 
      this.iravalue="Uploaded"
    }
    if(data.ira==false){
      this.irabtn='btn btn-danger btn-sm'; 
      this.iravalue="Not Uploaded"
    }
    if(data.mcm_TNC){
      this.mcmTncBtn='btn btn-success btn-sm'; 
      this.mcmTncValue="Uploaded"
    }
    if(data.mcm_TNC==false){
      this.mcmTncBtn='btn btn-danger btn-sm'; 
      this.mcmTncValue="Not Uploaded"
    }
    
    if(data.mcm_MRP){
      this.mcmMrpBtn='btn btn-success btn-sm'; 
      this.mcmMrpValue="Uploaded"
    }
    
    if(data.mcm_MRP==false){
      this.mcmMrpBtn='btn btn-danger btn-sm'; 
      this.mcmMrpValue="Not Uploaded"
    }
    
    if(data.mcm_MGP){
      this.mcmMGPbtn='btn btn-success btn-sm'; 
      this.mcmMGPValue="Uploaded"
    }
    
    if(data.mcm_MGP==false){
      this.mcmMGPbtn='btn btn-danger btn-sm'; 
      this.mcmMGPValue="Not Uploaded"
    }
    if(data.mcm_AOC){
      this.mcmAOCbtn='btn btn-success btn-sm'; 
      this.mcmAOCValue="Uploaded"
    }
    
    if(data.mcm_AOC==false){
      this.mcmAOCbtn='btn btn-danger btn-sm'; 
      this.mcmAOCValue="Not Uploaded"
    }
    if(data.mcm_COC){
      this.mcmCOCBtn='btn btn-success btn-sm'; 
      this.mcmCOCValue="Uploaded"
    }
    
    if(data.mcm_COC==false){
      this.mcmCOCBtn='btn btn-danger btn-sm'; 
      this.mcmCOCValue="Not Uploaded"
    }
    if(data.mcm_VAP){
      this.mcmVaptbtn='btn btn-success btn-sm'; 
      this.mcmVaptValue="Uploaded"
    }
    
    if(data.mcm_VAP==false){
      this.mcmVaptbtn='btn btn-danger btn-sm'; 
      this.mcmVaptValue="Not Uploaded"
    }
if(val){
  debugger
  this.btnflag='btn btn-success btn-sm'; 
  this.btnvalue="Verified"
  this.btnvalue1="Uploaded"
 // alert(this.btnflag)
}
else{
  this.btnflag="btn btn-danger btn-sm"
  this. btnvalue="Pending"
  this.btnvalue1="Pending"


}
  });
}

retryPanGstinMca(){
  if(this.verificationReponse.panVerification==false||this.verificationReponse.gstn==false||this.verificationReponse.mca==false){
   // alert("I am Clickable for Pan Gstin Mca ")
    
    this.apiHttpService.post(`${API_URL}/karzaimpl/${this.merchantid}`, null).subscribe((data) => {
// alert("retryPanGstinMca=="+JSON.stringify(data));
this.getBtnFlag(this.merchantid);

    } ) 
    }
       
  }
 

retryWebsite(){
  if(this.verificationReponse.webCrawler==false){
    //alert("I am Clickable for Website")
   
    this.apiHttpService.post(`${API_URL}/webVerify/${this.merchantid}`, null).subscribe((data) => {
      // alert("retryWebsite=="+JSON.stringify(data))
      this.getBtnFlag(this.merchantid);
      
          } ) 
   // this.getBtnFlag(this.merchantid);
  }
}
retryAml(){
  if(this.verificationReponse.amlVerify==false){
   
    this.apiHttpService.post(`${API_URL}/amltest/${this.merchantid}`, null).subscribe((data) => {
      // alert("retryAml=="+JSON.stringify(data))
      this.getBtnFlag(this.merchantid);
      
          } ) 
   // alert("I am Clickable for Aml")
    //this.getBtnFlag(this.merchantid);
  }
}
  async loadHtmlFile() {
    debugger
    try {
      const filePath = '../../../../assets/images/merchant_summary_table.html'; // Replace with your file's path
      this.htmlContent = await this.merchantService.getHtmlFile(filePath);
    } catch (error) {
      console.error('Error loading HTML file:', error);
    }
  }
}